import { actionTypes } from '../../constants/actionTypes';

export interface ISetVisibleStickBottomAction {
  type: actionTypes.SET_VISIBLE_STICK_BOTTOM;
  payload: boolean;
}

export type TStickBottomActions = ISetVisibleStickBottomAction;

export function setVisibleStickBottom(isVisible: boolean): ISetVisibleStickBottomAction {
  return {
    type: actionTypes.SET_VISIBLE_STICK_BOTTOM,
    payload: isVisible,
  };
}
